export default "__VITE_ASSET__Xb9$6ENn__"